module.exports = __webpack_public_path__ + "static/lascaux_proj_01-6ee21d4db6b617e92d020ae8a0b585dc.jpg";